"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STRIPE_WISEPAD_METHOD = void 0;
exports.hasNativeTerminal = hasNativeTerminal;
exports.parseTerminalEventDetail = parseTerminalEventDetail;
exports.startNativeTerminalPayment = startNativeTerminalPayment;
exports.toStripeMinorUnits = toStripeMinorUnits;
var _api = require("./api");
const STRIPE_WISEPAD_METHOD = exports.STRIPE_WISEPAD_METHOD = 'stripe_wisepad';
function hasNativeTerminal() {
  return typeof window !== 'undefined' && window.AndroidTerminal && typeof window.AndroidTerminal.startTerminalPayment === 'function';
}
function parseTerminalEventDetail(raw) {
  if (raw == null) return {};
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return {};
    }
  }
  if (typeof raw === 'object') return raw;
  return {};
}

/** Devises Stripe sans décimales — montant panier = unité Stripe. */
const ZERO_DECIMAL = new Set(['bif', 'clp', 'djf', 'gnf', 'jpy', 'kmf', 'krw', 'mga', 'pyg', 'rwf', 'ugx', 'vnd', 'vuv', 'xaf', 'xof', 'xpf']);
function toStripeMinorUnits(amountMajor, currency = 'EUR') {
  const c = String(currency).toLowerCase();
  const value = Number(amountMajor);
  if (!Number.isFinite(value) || value <= 0) return 0;
  if (ZERO_DECIMAL.has(c)) return Math.round(value);
  return Math.round(value * 100);
}

/**
 * Lance le paiement WisePad natif.
 * - Flux CMS : { commandId }
 * - Flux New Cactus : { amountCents, currency } (sans commandId)
 */
function startNativeTerminalPayment({
  projectId,
  commandId,
  amountCents,
  currency
}) {
  if (!hasNativeTerminal() || !projectId) return false;
  const payload = {
    apiBaseUrl: _api.API_URI,
    projectId
  };
  if (commandId) {
    payload.commandId = commandId;
  } else if (amountCents && currency) {
    payload.amountCents = amountCents;
    payload.currency = currency;
  } else {
    return false;
  }
  window.AndroidTerminal.startTerminalPayment(JSON.stringify(payload));
  return true;
}